// extracted by mini-css-extract-plugin
export default {"profile-info-sec":"ProfileInfo_profile-info-sec__kAbeM","profile-data":"ProfileInfo_profile-data__Tgn4m"};